// Persistent add-taak input, sticky onder de AppBar op desktop.
import { Box } from '@mui/material';
import QuickAddFieldWithHint from '@/components/layout/QuickAddFieldWithHint';
import {
  QUICK_ADD_DESKTOP_MAX_WIDTH_PX,
  QUICK_ADD_INPUT_SX,
} from '@/components/layout/quickAddStyles';

export default function QuickBar() {
  return (
    <Box
      sx={{
        flex: '1 1 auto',
        minWidth: 0,
        maxWidth: QUICK_ADD_DESKTOP_MAX_WIDTH_PX,
      }}
    >
      <QuickAddFieldWithHint sx={QUICK_ADD_INPUT_SX} />
    </Box>
  );
}
